





























































































































































































































































// import DataPasien from "@/services/DataPasien";
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import ModalDetailKonsul from "@/components/modal/CardModalDetailKonsul.vue";
import { storeKonsul } from "@/store/modules/konsul";
import { userModule } from "@/store/modules/user";
import moment from "moment";
import DokterAutoComplete from "@/components/pemeriksaan/assesmen/DokterAutoComplete.vue";
import UnitAutoComplete from "@/components/pemeriksaan/assesmen/UnitAutoComplete.vue";
import DataKonsul from "@/services/DataKonsul";
// import { storeUnit } from "@/store/modules/unit";
import { appModule } from "@/store/modules/app";
import { storeDokter } from "@/store/modules/dokter";
import storeListPasienRalan from "@/store/modules/new/ListPasienRalan";
import SuratKonsul from "@/services/new/SuratKonsul";

@Component({
  components: {
    ModalDetailKonsul,
    DokterAutoComplete,
    UnitAutoComplete
  }
})
export default class PasienKonsulRujukInternalCard extends Vue {
  @Prop() readonly title: string;
  @Prop() readonly type: string;

  modalOpen = false;
  today = moment().format("YYYY-MM-DD");
  minDate = moment()
    .subtract(3, "days")
    .format("YYYY-MM-DD");
  data = {};
  dokter = {};
  unit = {};
  isShowFilter = false;
  showAlertDiffDate = false;
  activeKonsulId = null;
  activeDokterId = null;
  bypassCode = null;
  alertDiffDateMsg = null;
  showAlertDiffDateBypass = false;

  toggleAlertDiffDateBypass() {
    this.showAlertDiffDateBypass = this.showAlertDiffDateBypass ? false : true;
  }

  get showOkAlertDiffDate() {
    return this.bypassCode?.length > 2;
  }

  get loadingList() {
    return storeKonsul.loading;
  }

  get headers() {
    const headers = [
      {
        text: "No.RM/ Nama",
        value: "rm",
        align: "left",
        width: "20%"
      },
      {
        text: "Tgl/ Dokter Pengirim",
        value: "tgl_kirim",
        align: "left",
        width: "20%"
      },
      {
        text: "Jenis",
        value: "type",
        align: "left",
        width: "10%"
      },
      {
        text: "Tujuan",
        value: "dokter_tujuan",
        align: "left",
        width: "10%"
      },
      { text: "Diagnosa", value: "diagnosis", align: "left", width: "5vh" },
      { text: "Masalah", value: "masalah", align: "left", width: "5vh" },
      {
        text: "Konsultasi yg Diminta",
        value: "konsultasi",
        align: "left",
        width: "5vh"
      },
      { text: "Aksi", value: "id", align: "left", width: "5%" }
    ];

    return headers;
  }

  // mounted() {
  //   storeKonsul.SET_PARAM_UNIT(this.stateuser.unit_group_id);
  //   storeKonsul.SET_PARAM_TGL_START(this.minDate);
  //   storeKonsul.SET_PARAM_TGL_END(this.today);

  //   storeKonsul.getListKonsulWithoutParam();
  // }

  mounted() {
    storeKonsul.SET_PARAM_TGL_START(this.minDate);
    storeKonsul.SET_PARAM_TGL_END(this.today);

    if (this.stateuser.unit_id < "50") {
      storeKonsul.SET_PARAM_UNIT(this.stateuser.unit_group_id);
      storeKonsul.getListKonsulWithoutParam();
    } else {
      storeKonsul.SET_PARAM_UNIT(this.stateuser.unit_id);
      storeKonsul.getListKonsulRanap();
    }
  }

  typeTitle(type = null) {
    console.log("type title", type);
    if (type == "konsul") {
      return "Konsul";
    } else if (type == "rjkint") {
      return "Rujukan Internal";
    } else {
      return type;
    }
  }

  pemeriksaanKonsul(item) {
    storeKonsul.actKonsul_on_id(item["id"]);
    this.modalOpen = true;
  }

  toggleFilter() {
    this.isShowFilter = !this.isShowFilter;
  }

  @Watch("isShowFilter")
  changedIsShowFilter(val) {
    if (!val) {
      this.clearFilter();
    }
  }

  get stateuser() {
    return userModule.user;
  }

  get statelistkonsul() {
    return storeKonsul.listKonsul;
  }

  get listKonsul() {
    // const list = Array.isArray(this.statelistkonsul)
    //   ? this.statelistkonsul.filter(item => !item.is_accepted)
    //   : [];
    const list = this.statelistkonsul.filter(item => {
      return (
        !item.is_accepted &&
        parseInt(item.dokter_pengirim?.id) != this.stateuser.id &&
        (userModule.isMedis && item.dokter_tujuan
          ? parseInt(item.dokter_tujuan.id) == this.stateuser.id
          : true)
      );
    });
    let rtn = list;

    if (this.dokter["id"]) {
      rtn = list.filter(item => item.dokter_pengirim.id == this.dokter["id"]);
    }

    if (this.unit["id"]) {
      rtn = list.filter(item => item.unit_pengirim.id == this.unit["id"]);
    }

    // if (this.stateuser.unit_id >= "50") {
    //   if (this.stateuser.profesi == "Dokter") {
    //     rtn = list.filter(
    //       item => item.unit_tujuan?.id == this.stateuser.spesialis_cat?.id
    //     );
    //   }
    // }

    return rtn;
  }

  get counter() {
    return this.listKonsul.length;
  }

  get canAcceptKonsulForSelf() {
    return (
      this.stateuser.profesi === "Dokter" ||
      this.stateuser.profesi === "Psikolog"
    );
  }

  setDokter(val) {
    this.dokter = val;
    // this.list = this.statelistkonsul;
    // if (this.dokter["id"] != undefined) {
    //   this.list = this.filterKonsul(this.list);
    // }
  }

  setUnit(val) {
    this.unit = val;
    // this.list = this.statelistkonsul;
    // if (this.unit["id"] != undefined) {
    //   this.list = this.filterKonsul(this.list);
    // }
  }

  terima(konsulId, dokterId, item = null) {
    this.modalOpen = false;
    this.showAlertDiffDate = false;

    if (this.stateuser.unit_id < "50") {
      const nmPx = item?.nama;
      const q = confirm(
        "Terima pasien atas nama " + nmPx + " untuk Anda periksa?"
      );

      if (q) {
        DataKonsul.terimaKonsul(
          konsulId,
          userModule.user.unit_id,
          dokterId,
          this.bypassCode
        )
          .then(resp => {
            appModule.NoticeDelay(resp.message);

            // kalo user dokter tawarkan untuk langsung jawab
            if (userModule.isMedis) {
              const conf = confirm(
                "Langsung jawab Surat Rujukan Internal pasien ini?"
              );

              if (conf) {
                const konsul = this.listKonsul.find(
                  item => item.id == konsulId
                );

                // this.$emit("jwbKonsul", [
                //   konsul.register,
                //   "tab-jwbkonsul",
                //   konsul.rm
                // ]);

                this.$router.push({
                  name: `pemeriksaan`,
                  params: {
                    register: resp.data.accepted_register_id,
                    page: "tab-jwbkonsul",
                    rm: konsul["rm"]
                  }
                });
              } else {
                const drCdocId = storeDokter.list.find(
                  item => item.id == dokterId
                );

                storeListPasienRalan.getListByDokter(drCdocId?.c_doc_id);
              }
            } else {
              storeListPasienRalan.getListWithoutParam();
            }

            this.reload();
          })
          .catch(err => {
            if (err.response.data?.err_code == "WARN_DIFFDATE") {
              appModule.closeErrorAlert();

              this.activeKonsulId = konsulId;
              this.activeDokterId = dokterId;
              this.showAlertDiffDate = true;
              this.alertDiffDateMsg = err.response.data.message;
            }
          });
      }
    } else {
      const nmPx = item?.nama;
      const q = confirm(
        "Terima pasien atas nama " + nmPx + " untuk Anda periksa?"
      );

      if (q) {
        SuratKonsul.terimaByRanap(konsulId, {
          unit_penerima_id: userModule.user.unit_id,
          dokter_penerima_id: dokterId
        }).then(resp => {
          if (resp.data) {
            const { data, message } = resp.data;

            appModule.NoticeDelay(message);

            this.$router.push({
              name: `pemeriksaan-ranap`,
              params: {
                register: data.accepted_register_id,
                page: "tab-konsul",
                rm: data.rm
              }
            });
          }
        });
      }
    }
  }

  @Watch("showAlertDiffDate")
  changeShowAlertDiffDate(val) {
    if (!val) {
      this.activeKonsulId = null;
      this.activeDokterId = null;
      this.alertDiffDateMsg = null;
      this.bypassCode = null;
      this.showAlertDiffDateBypass = false;
    }
  }

  get stateerrlistkonsul() {
    return storeKonsul.errlistkonsul;
  }

  get stateDetailkonsul() {
    // let konsul = storeKonsul.konsul;
    // konsul = this.filterKonsul(konsul);
    // return konsul;
    return storeKonsul.konsul;
  }

  get stateloading() {
    return storeKonsul.loading;
  }

  get listDokterKlinik() {
    return storeDokter.listOnKlinik;
  }

  reload() {
    if (this.stateuser.unit_id < "50") {
      storeKonsul.getListKonsulWithoutParam();
    } else {
      storeKonsul.getListKonsulRanap();
    }
  }

  clearFilter() {
    this.dokter = {};
    this.unit = {};
  }

  getHumanDate(date) {
    return date ? moment(date, "DD-MM-YYYY").format("DD MMMM YYYY") : "";
  }
  lihat(reg, rm) {
    // console.log(rm);
    this.data = {
      register: reg,
      page: "page-soap",
      rm: rm
    };
    this.$emit("addSOAP", this.data);
    return this.data;
  }
  detailKonsul(v) {
    this.$emit("addSOAP", v);
  }
}
